export enum AdjustmentStatusEnum {
  Draft = 'Draft',
  InProgress = 'In Progress',
  Complete = 'Complete',
  Cancelled = 'Cancelled',
}
